import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { tap } from "rxjs/operators";
import { User } from "../model/user";
import { Injectable } from "@angular/core";
import { UserAuth } from "../model/user.auth";
import { HttpClient } from "@angular/common/http";
import { setUser } from "src/app/store/auth/auth.actions";
import { BaseHttpService } from "src/app/shared/services/base.http.service";

@Injectable()
export class AuthService extends BaseHttpService {
  constructor(private http: HttpClient, public store: Store<any>) {
    super();
    this.loadUserFromLocalStorage();
  }

  authenticate(form: UserAuth): Observable<User> {
    return this.http
      .post<User>(`${this.apiUrl}/api/accounts/admin/Login`, form)
      .pipe(tap(response => this.handleAuthentication(response)));
  }

  updatePassword(data: any) {
    return this.http.post(`${this.apiUrl}/api/accounts/updatepassword`, data);
  }

  saveUser(user: User): void {
    localStorage.setItem("user", JSON.stringify(user));
    this.store.dispatch(setUser({ user }));
  }

  handleAuthentication(response: User): void {
    if (response && response.token) {
      const user = {
        ...response,
        role: response.role || "Admin",
      };
      this.saveUser(user);
    }
  }

  loadUserFromLocalStorage(): void {
    const user = localStorage.getItem("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      if (this.isTokenExpired(parsedUser.token)) {
        localStorage.removeItem("user");
      }
      else {
        this.store.dispatch(setUser({ user: parsedUser }));
      }
    }
  }

  getUserRole(): Observable<string> {
    return this.store.select(state => state.auth.user.role);
  }

  isTokenExpired(token: string): boolean {
    const expiry = JSON.parse(atob(token.split(".")[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }
}
